/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssignWeaknessRequest,
  ResolveWeaknessRequest,
  WeaknessInstanceEntity,
} from '../models/index';
import {
    AssignWeaknessRequestFromJSON,
    AssignWeaknessRequestToJSON,
    ResolveWeaknessRequestFromJSON,
    ResolveWeaknessRequestToJSON,
    WeaknessInstanceEntityFromJSON,
    WeaknessInstanceEntityToJSON,
} from '../models/index';

export interface AssignWeaknessOperationRequest {
    weaknessId: string;
    assignWeaknessRequest: AssignWeaknessRequest;
    sessionId?: string;
}

export interface CreateWeaknessRequest {
    weaknessInstanceEntity: WeaknessInstanceEntity;
    sessionId?: string;
}

export interface DeleteWeaknessRequest {
    weaknessId: string;
    sessionId?: string;
}

export interface GetAffectedAssetsRequest {
    weaknessId: string;
    sessionId?: string;
}

export interface GetWeaknessRequest {
    weaknessId: string;
    sessionId?: string;
}

export interface GetWeaknessStatisticsRequest {
    sessionId?: string;
}

export interface GetWeaknessesRequest {
    page?: number;
    pageSize?: number;
    weaknessType?: string;
    resolutionStatus?: string;
    framework?: string;
    sessionId?: string;
}

export interface ResolveWeaknessOperationRequest {
    weaknessId: string;
    resolveWeaknessRequest: ResolveWeaknessRequest;
    sessionId?: string;
}

export interface UpdateWeaknessRequest {
    weaknessId: string;
    weaknessInstanceEntity: WeaknessInstanceEntity;
    sessionId?: string;
}

/**
 * WeaknessesApi - interface
 * 
 * @export
 * @interface WeaknessesApiInterface
 */
export interface WeaknessesApiInterface {
    /**
     * Assign a weakness to a user, team, or group
     * @summary Assign weakness
     * @param {string} weaknessId Weakness instance ID
     * @param {AssignWeaknessRequest} assignWeaknessRequest 
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeaknessesApiInterface
     */
    assignWeaknessRaw(requestParameters: AssignWeaknessOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Assign a weakness to a user, team, or group
     * Assign weakness
     */
    assignWeakness(requestParameters: AssignWeaknessOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Create a new weakness instance (manual creation - primary source is integrations)
     * @summary Create weakness
     * @param {WeaknessInstanceEntity} weaknessInstanceEntity 
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeaknessesApiInterface
     */
    createWeaknessRaw(requestParameters: CreateWeaknessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Create a new weakness instance (manual creation - primary source is integrations)
     * Create weakness
     */
    createWeakness(requestParameters: CreateWeaknessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Soft delete a weakness instance (retains for audit/compliance)
     * @summary Delete weakness
     * @param {string} weaknessId Weakness instance ID
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeaknessesApiInterface
     */
    deleteWeaknessRaw(requestParameters: DeleteWeaknessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Soft delete a weakness instance (retains for audit/compliance)
     * Delete weakness
     */
    deleteWeakness(requestParameters: DeleteWeaknessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get all assets affected by this weakness
     * @summary Get affected assets
     * @param {string} weaknessId Weakness instance ID
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeaknessesApiInterface
     */
    getAffectedAssetsRaw(requestParameters: GetAffectedAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get all assets affected by this weakness
     * Get affected assets
     */
    getAffectedAssets(requestParameters: GetAffectedAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get detailed information about a weakness instance
     * @summary Get weakness by ID
     * @param {string} weaknessId Weakness instance ID
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeaknessesApiInterface
     */
    getWeaknessRaw(requestParameters: GetWeaknessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get detailed information about a weakness instance
     * Get weakness by ID
     */
    getWeakness(requestParameters: GetWeaknessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get statistics about weaknesses (total, by type, by status)
     * @summary Get weakness statistics
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeaknessesApiInterface
     */
    getWeaknessStatisticsRaw(requestParameters: GetWeaknessStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get statistics about weaknesses (total, by type, by status)
     * Get weakness statistics
     */
    getWeaknessStatistics(requestParameters: GetWeaknessStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get paginated list of active weakness instances
     * @summary List weaknesses
     * @param {number} [page] Page number (0-indexed)
     * @param {number} [pageSize] Page size
     * @param {string} [weaknessType] Weakness type filter
     * @param {string} [resolutionStatus] Resolution status filter
     * @param {string} [framework] Framework filter
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeaknessesApiInterface
     */
    getWeaknessesRaw(requestParameters: GetWeaknessesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get paginated list of active weakness instances
     * List weaknesses
     */
    getWeaknesses(requestParameters: GetWeaknessesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Mark a weakness as resolved
     * @summary Resolve weakness
     * @param {string} weaknessId Weakness instance ID
     * @param {ResolveWeaknessRequest} resolveWeaknessRequest 
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeaknessesApiInterface
     */
    resolveWeaknessRaw(requestParameters: ResolveWeaknessOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Mark a weakness as resolved
     * Resolve weakness
     */
    resolveWeakness(requestParameters: ResolveWeaknessOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Update an existing weakness instance
     * @summary Update weakness
     * @param {string} weaknessId Weakness instance ID
     * @param {WeaknessInstanceEntity} weaknessInstanceEntity 
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeaknessesApiInterface
     */
    updateWeaknessRaw(requestParameters: UpdateWeaknessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Update an existing weakness instance
     * Update weakness
     */
    updateWeakness(requestParameters: UpdateWeaknessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class WeaknessesApi extends runtime.BaseAPI implements WeaknessesApiInterface {

    /**
     * Assign a weakness to a user, team, or group
     * Assign weakness
     */
    async assignWeaknessRaw(requestParameters: AssignWeaknessOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['weaknessId'] == null) {
            throw new runtime.RequiredError(
                'weaknessId',
                'Required parameter "weaknessId" was null or undefined when calling assignWeakness().'
            );
        }

        if (requestParameters['assignWeaknessRequest'] == null) {
            throw new runtime.RequiredError(
                'assignWeaknessRequest',
                'Required parameter "assignWeaknessRequest" was null or undefined when calling assignWeakness().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/weaknesses/{weaknessId}/assign`;
        urlPath = urlPath.replace(`{${"weaknessId"}}`, encodeURIComponent(String(requestParameters['weaknessId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssignWeaknessRequestToJSON(requestParameters['assignWeaknessRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Assign a weakness to a user, team, or group
     * Assign weakness
     */
    async assignWeakness(requestParameters: AssignWeaknessOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.assignWeaknessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new weakness instance (manual creation - primary source is integrations)
     * Create weakness
     */
    async createWeaknessRaw(requestParameters: CreateWeaknessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['weaknessInstanceEntity'] == null) {
            throw new runtime.RequiredError(
                'weaknessInstanceEntity',
                'Required parameter "weaknessInstanceEntity" was null or undefined when calling createWeakness().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/weaknesses`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WeaknessInstanceEntityToJSON(requestParameters['weaknessInstanceEntity']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Create a new weakness instance (manual creation - primary source is integrations)
     * Create weakness
     */
    async createWeakness(requestParameters: CreateWeaknessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.createWeaknessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Soft delete a weakness instance (retains for audit/compliance)
     * Delete weakness
     */
    async deleteWeaknessRaw(requestParameters: DeleteWeaknessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['weaknessId'] == null) {
            throw new runtime.RequiredError(
                'weaknessId',
                'Required parameter "weaknessId" was null or undefined when calling deleteWeakness().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/weaknesses/{weaknessId}`;
        urlPath = urlPath.replace(`{${"weaknessId"}}`, encodeURIComponent(String(requestParameters['weaknessId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Soft delete a weakness instance (retains for audit/compliance)
     * Delete weakness
     */
    async deleteWeakness(requestParameters: DeleteWeaknessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.deleteWeaknessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all assets affected by this weakness
     * Get affected assets
     */
    async getAffectedAssetsRaw(requestParameters: GetAffectedAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['weaknessId'] == null) {
            throw new runtime.RequiredError(
                'weaknessId',
                'Required parameter "weaknessId" was null or undefined when calling getAffectedAssets().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/weaknesses/{weaknessId}/affected-assets`;
        urlPath = urlPath.replace(`{${"weaknessId"}}`, encodeURIComponent(String(requestParameters['weaknessId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get all assets affected by this weakness
     * Get affected assets
     */
    async getAffectedAssets(requestParameters: GetAffectedAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getAffectedAssetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get detailed information about a weakness instance
     * Get weakness by ID
     */
    async getWeaknessRaw(requestParameters: GetWeaknessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['weaknessId'] == null) {
            throw new runtime.RequiredError(
                'weaknessId',
                'Required parameter "weaknessId" was null or undefined when calling getWeakness().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/weaknesses/{weaknessId}`;
        urlPath = urlPath.replace(`{${"weaknessId"}}`, encodeURIComponent(String(requestParameters['weaknessId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get detailed information about a weakness instance
     * Get weakness by ID
     */
    async getWeakness(requestParameters: GetWeaknessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getWeaknessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get statistics about weaknesses (total, by type, by status)
     * Get weakness statistics
     */
    async getWeaknessStatisticsRaw(requestParameters: GetWeaknessStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/weaknesses/statistics`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get statistics about weaknesses (total, by type, by status)
     * Get weakness statistics
     */
    async getWeaknessStatistics(requestParameters: GetWeaknessStatisticsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getWeaknessStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get paginated list of active weakness instances
     * List weaknesses
     */
    async getWeaknessesRaw(requestParameters: GetWeaknessesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['weaknessType'] != null) {
            queryParameters['weaknessType'] = requestParameters['weaknessType'];
        }

        if (requestParameters['resolutionStatus'] != null) {
            queryParameters['resolutionStatus'] = requestParameters['resolutionStatus'];
        }

        if (requestParameters['framework'] != null) {
            queryParameters['framework'] = requestParameters['framework'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/weaknesses`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get paginated list of active weakness instances
     * List weaknesses
     */
    async getWeaknesses(requestParameters: GetWeaknessesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getWeaknessesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark a weakness as resolved
     * Resolve weakness
     */
    async resolveWeaknessRaw(requestParameters: ResolveWeaknessOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['weaknessId'] == null) {
            throw new runtime.RequiredError(
                'weaknessId',
                'Required parameter "weaknessId" was null or undefined when calling resolveWeakness().'
            );
        }

        if (requestParameters['resolveWeaknessRequest'] == null) {
            throw new runtime.RequiredError(
                'resolveWeaknessRequest',
                'Required parameter "resolveWeaknessRequest" was null or undefined when calling resolveWeakness().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/weaknesses/{weaknessId}/resolve`;
        urlPath = urlPath.replace(`{${"weaknessId"}}`, encodeURIComponent(String(requestParameters['weaknessId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResolveWeaknessRequestToJSON(requestParameters['resolveWeaknessRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Mark a weakness as resolved
     * Resolve weakness
     */
    async resolveWeakness(requestParameters: ResolveWeaknessOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.resolveWeaknessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing weakness instance
     * Update weakness
     */
    async updateWeaknessRaw(requestParameters: UpdateWeaknessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['weaknessId'] == null) {
            throw new runtime.RequiredError(
                'weaknessId',
                'Required parameter "weaknessId" was null or undefined when calling updateWeakness().'
            );
        }

        if (requestParameters['weaknessInstanceEntity'] == null) {
            throw new runtime.RequiredError(
                'weaknessInstanceEntity',
                'Required parameter "weaknessInstanceEntity" was null or undefined when calling updateWeakness().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/weaknesses/{weaknessId}`;
        urlPath = urlPath.replace(`{${"weaknessId"}}`, encodeURIComponent(String(requestParameters['weaknessId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: WeaknessInstanceEntityToJSON(requestParameters['weaknessInstanceEntity']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Update an existing weakness instance
     * Update weakness
     */
    async updateWeakness(requestParameters: UpdateWeaknessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.updateWeaknessRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
